import { getWidgetViewKind, VIEW_KIND } from '../widgets/registry';

/**
 * KPI / gauge widgets always use a single calendar month (year + month).
 * Tables and charts honor the selected range grain (yearly / quarterly / …).
 */
export function widgetUsesRangeGrain(widget) {
  const kind = getWidgetViewKind(widget?.type);
  if (kind === VIEW_KIND.stat || kind === VIEW_KIND.gauge || kind === VIEW_KIND.progress || widget?.type === 'progress_bar') return false;
  return true;
}

export function widgetRunPeriod(widget, period = {}) {
  if (widgetUsesRangeGrain(widget)) return period;
  if ((period.period || 'monthly') === 'monthly') return period;
  return {
    ...period,
    period: 'monthly',
  };
}
